/*
 * WeekplanCalendar Messages
 *
 * This contains all the text for the WeekplanCalendar component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  revokeShiftApplication: {
    id: 'app.components.RevokeShiftApplicationButton.revokeShiftApplication',
    defaultMessage: 'Revoke Application',
  },
  revokeShiftApplicationSuccess: {
    id: 'app.containers.RevokeShiftApplicationButton.revokeShiftApplicationSuccess',
    defaultMessage: 'Successfully revoked shift application',
  },
  revokeShiftApplicationFailure: {
    id: 'app.containers.RevokeShiftApplicationButton.revokeShiftApplicationFailure',
    defaultMessage: 'Shift application could not be revoked',
  },
});
